import type {BuildingInsightsResponse} from "../components/SolarMap/SolarAPI/solar.ts";

const DEFAULT_YEARLY_KWH_PER_PANEL = 320;
const REFERENCE_PANEL_WATTS = 400;

const isFiniteNumber = (value: unknown): value is number => typeof value === "number" && Number.isFinite(value);

export const average = (values: number[]): number | null => {
    const validValues = values.filter(isFiniteNumber);

    if (validValues.length === 0) {
        return null;
    }

    return validValues.reduce((sum, value) => sum + value, 0) / validValues.length;
};

export const getKwPerYearAndModuleFromBuildingInsights = (
    buildingInsights: BuildingInsightsResponse,
    powerClass: number,
    defaultYearlyKwhPerPanel = DEFAULT_YEARLY_KWH_PER_PANEL,
): number => {
    const yearlyEnergyValues = buildingInsights.solarPotential.solarPanels.map((panel) => panel.yearlyEnergyDcKwh);
    const averageYearlyKwh = average(yearlyEnergyValues) ?? defaultYearlyKwhPerPanel;

    return (averageYearlyKwh / REFERENCE_PANEL_WATTS) * powerClass;
};

export {DEFAULT_YEARLY_KWH_PER_PANEL, REFERENCE_PANEL_WATTS};
